/**
 * 
 * @param {File} file Archivo a validar.
 * @param {object} [options={}] - Objeto de configuración opcional.
 * @param {number} [options.maxSizeMB=20] - Tamaño maximo del archivo en MB.
 * @param {string[]} [options.allowedMimeTypes=['application/pdf']] - Tipos MIME aceptados.
 * @param {string[]} [options.allowedExtensions=['.pdf']] - Extensiones de archivo permitidas.
 * 
 * @returns {{ok: boolean, msg: string|null}} Resultado de la validación.
 * @example 
 * const { ok, msg } = validateFile(myFile, 5, ['image/png'], ['.png']);
 * if (!ok) console.error(msg);
 */
export const validarArchivo = ( file, { 
  maxSizeMB = 10, 
  allowedMimeTypes = ['application/pdf'], 
  allowedExtensions = ['.pdf'] 
} = {} ) => {

  if (!file) {
    return { ok: false, msg: 'No se seleccionó ningún archivo' };
  }

  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  // Validar MIME
  if (
    allowedMimeTypes.length &&
    !allowedMimeTypes.includes(file.type)
  ) {
    return { 
      ok: false,
      msg:'Tipo de archivo no permitido'
    };
  }

  // Validar extensión
  const fileName = file.name.toLowerCase();
  const hasValidExtension = allowedExtensions.some(ext =>
    fileName.endsWith(ext.toLowerCase())
  );

  if (allowedExtensions.length && !hasValidExtension) {
    return { 
      ok: false,
      msg: `Extensión no permitida (${allowedExtensions.join(', ')})`
    };
  }

  // Validar tamaño
  if (file.size > maxSizeBytes) {
    return { 
      ok: false, 
      msg: `El archivo supera el tamaño máximo de ${maxSizeMB}MB` 
    };
  }

  return { ok: true, msg: null };
};

// Uso para imagenes
// validarArchivo(file, {
//   maxSizeMB: 5,
//   allowedMimeTypes: ['image/png', 'image/jpeg'],
//   allowedExtensions: ['.png', '.jpg', '.jpeg']
// });
// Uso para archivos varios
// validarArchivo(file, {
//   maxSizeMB: 50,
//   allowedExtensions: ['.pdf', '.docx', '.xlsx']
// });